import { BuiltinValueObject } from './BuiltinValueObject';
import { BuiltinType } from './types';
export class BuiltinInstanceOf extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.types = new Set([BuiltinType.InstanceOf, BuiltinType.ValueObject]);
    }
}

//# sourceMappingURL=BuiltinInstanceOf.js.map
